import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import styled from "styled-components"

const PushContainer = styled.div`
  height: ${(props) => (props.isSecondMicroBannerExp ? "148px" : "104px")};
  opacity: 0;
  ${(props) => props.theme.mediaQueries.large`
    height: ${props.isSecondMicroBannerExp ? "194px" : "150px"};
  `}
  ${(props) =>
    props.inCart &&
    `
    display: block;
    ${props.theme.mediaQueries.tablet`
      display: none;
    `}
  `}
`

const HeaderPush = ({ isSecondMicroBannerExp, location }) => {
  const inCart = location.pathname.includes("cart")

  return (
    <PushContainer
      aria-hidden
      inCart={inCart}
      isSecondMicroBannerExp={isSecondMicroBannerExp}
    />
  )
}

HeaderPush.propTypes = {
  isSecondMicroBannerExp: PropTypes.bool,
  location: PropTypes.object,
}

const mapStateToProps = (state) => {
  const secondMicroBanner = state.sale.second_microbanner
  const secondMicroBannerExp = state.experiment.secondMicroBanner.variant_id

  return {
    isSecondMicroBannerExp: !!secondMicroBanner && secondMicroBannerExp === 1,
  }
}

export default connect(mapStateToProps)(withRouter(HeaderPush))
